export function getFirstAvailableVariantOptionId(options, manageVariantOptionStock) {
  // if stock is not managed, return the first option
  if (!manageVariantOptionStock) return options[0]._id;

  let i = 0;

  while (options[i]) {
    const option = options[i];

    // if stock is not set, retur this option
    if (typeof option.stock !== 'number') return option._id;

    // if stock is set, return the first option that has stock
    if (option.stock > 0) return option._id;

    i++;
  }
}

export default function getVariantsFormFields(variants, query = {}, draftCheckout = null) {
  if (!variants || !variants.length) return [];

  // set default values
  // return the preselected option if preselect is enabled
  const variantsFormFields = variants.reduce((obj, variant) => {
    if (variant.selectionType === 'quantity' || variant.selectionType === 'multiple') {
      if (variant.preselect?.enabled) {
        const preselectedOption = variant.options.find(
          option => option._id === variant.preselect.optionId,
        );

        if (
          !preselectedOption ||
          (variant.manageVariantOptionStock && preselectedOption.stock === 0)
        ) {
          obj[variant._id] = variant.options.map(option => ({
            optionId: option._id,
            quantity: 0,
          }));
        } else {
          obj[variant._id] = variant.options.map(option => ({
            optionId: option._id,
            quantity: preselectedOption._id === option._id ? variant.preselect.quantity || 1 : 0,
          }));
        }
      } else {
        obj[variant._id] = variant.options.map(option => ({
          optionId: option._id,
          quantity: 0,
        }));
      }
    } else if (variant.preselect?.enabled) {
      const option = variant.options.find(option => option._id === variant.preselect.optionId);

      if (!option || (variant.manageVariantOptionStock && option.stock === 0)) {
        obj[variant._id] = [];
      } else {
        obj[variant._id] = [
          {
            optionId: variant.preselect.optionId,
            quantity: variant.preselect.quantity || 1,
          },
        ];
      }
    } else {
      obj[variant._id] = [];
    }

    return obj;
  }, {});

  // Pre-populate from draft checkout variants if available
  if (draftCheckout?.variants && Array.isArray(draftCheckout.variants)) {
    draftCheckout.variants.forEach(draftVariant => {
      const variant = variants.find(v => v._id === draftVariant.variantId);

      if (variant && variantsFormFields[variant._id] !== undefined) {
        if (variant.selectionType === 'quantity' || variant.selectionType === 'multiple') {
          // Handle multiple/quantity variants with selectedOptions array
          if (draftVariant.selectedOptions && Array.isArray(draftVariant.selectedOptions)) {
            variantsFormFields[variant._id] = draftVariant.selectedOptions.map(selectedOption => ({
              optionId: selectedOption.optionId,
              quantity: selectedOption.quantity || 1,
            }));
          }
        } else {
          // Handle single selection variants
          if (draftVariant.selectedOptionId) {
            variantsFormFields[variant._id] = [
              {
                optionId: draftVariant.selectedOptionId,
                quantity: draftVariant.selectedOptionQuantity || 1,
              },
            ];
          }
        }
      }
    });
  }

  // match params to variant references (query params override draft data)
  Object.entries(query).forEach(([key, value]) => {
    const variant = variants.find(variant => variant.reference === key);

    if (variant && variant.selectionType !== 'quantity') {
      const variantOption = variant.options.find(variantOption => variantOption.sku === value);

      if (variant.manageVariantOptionStock && variantOption?.stock === 0) {
        variantsFormFields[variant._id] = [];
      } else if (variantOption) {
        variantsFormFields[variant._id] = [
          {
            optionId: variantOption._id,
            quantity: 1,
          },
        ];
      }
    }
  });

  return variantsFormFields;
}
